var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBluei = function SvgBluei(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.535,
    height: 15.828,
    viewBox: "0 0 16.535 15.828",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Information_2841887",
    transform: "translate(-1415 -1416.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17801",
    "data-name": "Group 17801",
    transform: "translate(1415 1416.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10674",
    "data-name": "Path 10674",
    d: "M1423.268,1415a7.922,7.922,0,1,1-8.268,7.914A8.1,8.1,0,0,1,1423.268,1415Zm0,.883a7.038,7.038,0,1,0,7.345,7.031A7.193,7.193,0,0,0,1423.268,1415.883Z",
    transform: "translate(-1415 -1415)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10675",
    "data-name": "Path 10675",
    d: "M4301.188,4003.86v4.056c0,1.813-2.188,1.813-2.188,0v-4.056C4299,4002.047,4301.188,4002.047,4301.188,4003.86Z",
    transform: "translate(-4291.973 -3996.267)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10676",
    "data-name": "Path 10676",
    d: "M4300.094,2552a1.111,1.111,0,0,1,1.094,1.124,1.094,1.094,0,1,1-2.188,0A1.109,1.109,0,0,1,4300.094,2552Z",
    transform: "translate(-4291.974 -2549.365)",
    fill: "#07a3c8"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBluei, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bluei.0b3fd5c8.svg";
export { ForwardRef as ReactComponent };